export default __webpack_public_path__ + "static/media/successGraphic.00d4ee0a.png";